<div class="card">
    <div class="header">
        <h3 class="text title">Detalle de la contrapartida</h3>
    </div>
    <div class="body">
        <app-info-syngenta [order]="orderSyngenta" *ngIf="isSyngentaBuyer || isAtanorBuyer" [isAtanorBuyer]="isAtanorBuyer"></app-info-syngenta>
        <app-info-exchange [order]="order" *ngIf="!isSyngentaBuyer && !isAtanorBuyer"></app-info-exchange>
    </div>
</div>